import { createShapeFromProperties } from 'lane-shared/properties';

import definition from './definition';

export { definition };

export const validationShape = createShapeFromProperties(
  definition.interactionData
);
